const featureFlags = {
  // ==========================================
  // Application Core & Infrastructure
  // ==========================================
  // Version management and update control
  herbieDashboardVersion: '0.0.1',
  forceUpdateVersionDashboard: false,

  // Early Access
  userEarlyAccess: false,

  // UI components and navigation
  sidebar: false,
  toggleFeatureFlag: false,
  sidebarIncidents: false,

  // PostHog kill switch: flip to false in LaunchDarkly to stop loading the
  // posthog-js SDK on new sessions (no identify, no survey fetch, no captures).
  posthogEnabled: true,

  // Developer and debugging tools
  developerTools: false,
  cobler: false,
  impersonate: false,

  // ==========================================
  // Monitoring & Device Tracking
  // ==========================================
  // Device monitoring and status
  activityCompletionStatus: false,
  devicesSlideSseTimeInMs: 10100,
  idleTime: true,
  removedDevice: false,
  showDeviceObservation: false,
  trackingForceVisibilityGeofence: false,
  /** LaunchDarkly key: `tracking-v2` — nova experiência de replay dedicado e histórico V2 */
  trackingV2: false,

  // ==========================================
  // Fleet Management
  // ==========================================

  sheetImportWithAi: false,

  // Fleet events and tracking
  enableFleetEvents: false,
  enableV2FleetEvents: false,
  libraryExtensionEventSource: false,

  // Driver management and identification
  driverIdentification: false,
  driverSuggestion: false,
  enableDriverAssociationPast: false,
  identifierAssociations: false,
  clusterPhotoSuggestions: false,

  // Vehicle and driver allow lists
  allowList: false,
  enableVehicleDriverAllowList: false,

  // ==========================================
  // Media & Video Features
  // ==========================================
  // Livestream functionality
  livestream: false,
  livestreamPage: false,
  livestreamMulti: false,
  disableLivestreamTimeRestriction: false,
  livestreamConfig: {
    liveTimeout: 60,
    bannerTimeout: 30,
    bannerThreshold: 5,
  },

  // Video playback and events
  videoImpactEvent: false,
  mediaEventLiveUpdate: false,
  videoEnhancedFeatures: false,
  videoEventSeverity: false,
  showObstructionDashboard: false,
  showMatchReview: false,
  multiCamVideoRequests: false,
  multiCamTimelapseRequests: false,
  cobliCamProRecordOff: true,

  // Video configuration
  disableWifiConfiguration: false,
  enforceCameraFeatures: false,

  // AI-powered
  aiChat: false,
  aiAnalyzeTrackingButton: false,
  aiVideosRecommendations: false,
  aiFilterAnnouncement: false,
  importIdentifierAi: false,
  invertedTokenFleetIds: false,
  aiUserModalUpdate: false,

  // ==========================================
  // AI Recommendations
  // ==========================================
  aiRecommendations: false,
  aiRecommendations2: false,
  poisRecommendations: false,
  /** LaunchDarkly key: `ai-risk-recognition-highlights` — floating risk-recognition card on the monitoring page */
  aiRiskRecognitionHighlights: false,

  // Audio features
  vehiclePopupAudioButton: false,

  // ==========================================
  // Analytics & Reporting
  // ==========================================
  // Fuel card integrations
  fuelCardAlelo: false,
  fuelCardManual: false,
  fuelCardMaxifrota: false,
  fuelCardPrime: false,
  fuelCardSodexo: false,
  fuelCardTicketlog: false,
  fuelCardCtasmart: false,
  fuelCardVolus: false,
  enableBrokenFuelCardIntegrationBanner: false,

  // Fuel AI research
  researchFuelAI: false,
  aiFuelOcr: false,

  // Reports and analytics
  showIncidentsReport: false,
  coblinator: false,
  safetyRankingDash: false,

  // ==========================================
  // Pages & Features
  // ==========================================
  // Navigation pages
  heavyUserMap: false,
  roadSpeedPage: true,
  expensesImportButton: true,
  finesPage: false,
  integrationsPage: false,
  businessManager: true,

  // Feature-specific pages
  maintenance: false,
  canUseNonAssociatedVehiclesToRegisterMaintenanceAndTransaction: false,
  prismicAlertsNotAdoptedCohort: false,

  // ==========================================
  // Account & User Experience
  // ==========================================
  // Account configuration
  cadastroDeIdentificadoresOrbital: false,
  ongoingActivationTasks: false,
  announcementCard: false,
  usersNovosAi: false,

  // Contract renewal popup
  contractRenewalConfig: false,

  // ==========================================
  // IoT & Device Control
  // ==========================================
  // Vehicle immobilizer
  enableImmobilizer: false,
  vehicleImmobilizer: false,

  // Remote connection
  useRemoteConnection: false,

  // ==========================================
  // Integrations & External Services
  // ==========================================
  // Address and location services
  internationalAddressAutocomplete: false,

  // Communication services
  // NOTE: keep the catalog key as `blipChat` because that's the LaunchDarkly
  // flag name that gates Intercom. The implementation is Intercom; only the
  // flag key is legacy.
  blipChat: false,

  // ==========================================
  // Development & Monitoring Tools
  // ==========================================
  // Datadog RUM (Real User Monitoring)
  ddRumSampleRate: 100,
  ddRumReplaySampleRate: 0,
  useDdRum: false,

  // Push notifications
  oneSignal: false,

  // Temporary flags
  showWarningBanner: false,
};

type FeatureFlags = typeof featureFlags;

export { featureFlags };
export default FeatureFlags;
